import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const createRefundApi = (data, callback, errorCallBack) => {
   
  return async (dispatch) => {
    
    formDataCommonFunction(data,apiConstants.PAYMENT_GATEWAY.CREATE_REFUND)
      .then((response) => {
        callback && callback(response)
      
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}